module.exports = __webpack_public_path__ + "e08a315d41eca4ceb482f6e45dfe3f85.jpg";